import React from "react"
import { useContent } from "src/components/App/Content"

import "./BannerImageSection.scss"

const BannerImageSection = () => {
  const content = useContent("rsvp-banner-section")
  return (
    <section className='banner-image-section'>
        <img src={content?.section?.media?.url} alt="Banner" className='banner-image' />
    </section>
  )
}

export default BannerImageSection
